// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — Dagre Layout for Org Chart
// ═══════════════════════════════════════════════════════════════

import dagre from 'dagre';
import type { Node, Edge } from '@xyflow/react';

export interface LayoutOptions {
  direction?: 'TB' | 'LR';
  nodeWidth?: number;
  nodeHeight?: number;
  rankSep?: number;
  nodeSep?: number;
}

const DEFAULTS: Required<LayoutOptions> = {
  direction: 'TB',
  nodeWidth: 220,
  nodeHeight: 120,
  rankSep: 80,
  nodeSep: 40,
};

export function calcularLayout(
  nodes: Node[],
  edges: Edge[],
  options?: LayoutOptions,
): { nodes: Node[]; edges: Edge[] } {
  const opts = { ...DEFAULTS, ...options };
  const g = new dagre.graphlib.Graph();

  g.setGraph({
    rankdir: opts.direction,
    ranksep: opts.rankSep,
    nodesep: opts.nodeSep,
    marginx: 40,
    marginy: 40,
  });
  g.setDefaultEdgeLabel(() => ({}));

  nodes.forEach((node) => {
    g.setNode(node.id, { width: opts.nodeWidth, height: opts.nodeHeight });
  });

  edges.forEach((edge) => {
    g.setEdge(edge.source, edge.target);
  });

  dagre.layout(g);

  const layoutedNodes = nodes.map((node) => {
    const pos = g.node(node.id);
    return {
      ...node,
      position: {
        x: pos.x - opts.nodeWidth / 2,
        y: pos.y - opts.nodeHeight / 2,
      },
    };
  });

  return { nodes: layoutedNodes, edges };
}
